import { LobbyImage } from '@colonist/types';
import { StoreProductType, StripeCheckoutTypes } from './BaseColonistStoreProduct.ts';
// TODO: Membership Check
// persisted enum, do not delete or change existing entries
export var ColonistCoinType = /*#__PURE__*/ function(ColonistCoinType) {
    ColonistCoinType[ColonistCoinType["CoinType1"] = 0] = "CoinType1";
    ColonistCoinType[ColonistCoinType["CoinType2"] = 1] = "CoinType2";
    ColonistCoinType[ColonistCoinType["CoinType3"] = 2] = "CoinType3";
    ColonistCoinType[ColonistCoinType["CoinType4"] = 3] = "CoinType4";
    ColonistCoinType[ColonistCoinType["CoinType5"] = 4] = "CoinType5";
    ColonistCoinType[ColonistCoinType["CoinType6"] = 5] = "CoinType6";
    return ColonistCoinType;
}({});
export var MobileCoinIAPSKUIds = /*#__PURE__*/ function(MobileCoinIAPSKUIds) {
    MobileCoinIAPSKUIds["CoinType1"] = "coin_id_1";
    MobileCoinIAPSKUIds["CoinType2"] = "coin_id_2";
    MobileCoinIAPSKUIds["CoinType3"] = "coin_id_3";
    MobileCoinIAPSKUIds["CoinType4"] = "coin_id_4";
    MobileCoinIAPSKUIds["CoinType5"] = "coin_id_5";
    MobileCoinIAPSKUIds["CoinType6"] = "coin_id_6";
    return MobileCoinIAPSKUIds;
}({});
export class ColonistCoinProduct {
    // BaseColonistStoreProduct
    getProductName() {
        const coinTranslation = {
            key: 'strings:storePage.coins.title',
            options: {
                count: this.getTotalCoinAmount()
            }
        };
        return coinTranslation;
    }
    getDefaultPrice() {
        return this.getUSDPriceWithSign();
    }
    // BaseColonistStoreProduct
    getTotalCoinAmount() {
        return this.baseCoinAmount + this.bonusCoinAmount;
    }
    getUSDPrice() {
        return this.price / 100;
    }
    getUSDPriceWithSign() {
        return `$${this.getUSDPrice()}`;
    }
    static getAllCoinProducts() {
        return this.products.values();
    }
    static getPurchaseProduct(coinType) {
        return this.products.get(coinType);
    }
    static getPurchaseProductFromMobileSKUId(mobileSKUId) {
        const productArray = Array.from(this.products.values());
        return productArray.find((product)=>product.mobileIAPSKUId === mobileSKUId);
    }
    static initProducts(discordSKUIds) {
        this.products.set(0, new ColonistCoinProduct({
            type: 0,
            baseCoinAmount: 650,
            bonusCoinAmount: 0,
            price: 499,
            discordSKUId: discordSKUIds.coin1,
            mobileIAPSKUId: "coin_id_1",
            lobbyImage: LobbyImage.CoinStack1,
            bannerText: undefined,
            isActive: ()=>true
        }));
        this.products.set(1, new ColonistCoinProduct({
            type: 1,
            baseCoinAmount: 1300,
            bonusCoinAmount: 80,
            price: 999,
            discordSKUId: discordSKUIds.coin2,
            mobileIAPSKUId: "coin_id_2",
            lobbyImage: LobbyImage.CoinStack2,
            bannerText: undefined,
            isActive: ()=>true
        }));
        this.products.set(2, new ColonistCoinProduct({
            type: 2,
            baseCoinAmount: 2600,
            bonusCoinAmount: 400,
            price: 1999,
            discordSKUId: discordSKUIds.coin3,
            mobileIAPSKUId: "coin_id_3",
            lobbyImage: LobbyImage.CoinStack3,
            bannerText: undefined,
            isActive: ()=>true
        }));
        this.products.set(3, new ColonistCoinProduct({
            type: 3,
            baseCoinAmount: 4500,
            bonusCoinAmount: 800,
            price: 3499,
            discordSKUId: discordSKUIds.coin4,
            mobileIAPSKUId: "coin_id_4",
            lobbyImage: LobbyImage.CoinStack4,
            bannerText: {
                key: 'strings:storePage.bestSeller'
            },
            isActive: ()=>true
        }));
        this.products.set(4, new ColonistCoinProduct({
            type: 4,
            baseCoinAmount: 6500,
            bonusCoinAmount: 1300,
            price: 4999,
            discordSKUId: discordSKUIds.coin5,
            mobileIAPSKUId: "coin_id_5",
            lobbyImage: LobbyImage.CoinStack5,
            bannerText: undefined,
            isActive: ()=>true
        }));
        this.products.set(5, new ColonistCoinProduct({
            type: 5,
            baseCoinAmount: 13000,
            bonusCoinAmount: 3000,
            price: 9999,
            discordSKUId: discordSKUIds.coin6,
            mobileIAPSKUId: "coin_id_6",
            lobbyImage: LobbyImage.CoinStack6,
            bannerText: {
                key: 'strings:storePage.bestValue'
            },
            isActive: ()=>true
        }));
    }
    constructor(source){
        // BaseColonistStoreProduct
        this.storeProductType = StoreProductType.Coin;
        this.stripeCheckoutType = StripeCheckoutTypes.Payment;
        this.itemQuantity = 1;
        Object.assign(this, source);
    }
}
ColonistCoinProduct.products = new Map();
